import { render, staticRenderFns } from "./ResultadoCita.vue?vue&type=template&id=5d68f151&scoped=true&"
import script from "./ResultadoCita.vue?vue&type=script&lang=js&"
export * from "./ResultadoCita.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoCita.vue?vue&type=style&index=0&id=5d68f151&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d68f151",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
